import React from 'react';
import MashkourPic from '../img/team/mashkour-pic.jpeg';
import OrianePic from '../img/team/oriane-pic.jpg';
import HamidPic from '../img/team/hamid-pic.jpg';

const TeamMembers = [
	{
		full_name: 'Oriane Zohou',
		role: "Designer & Content manager",
		image_url: OrianePic,
	},
	{
		full_name: 'Mashkour Abdel Aziz',
		role: "Frontend Developer",
		image_url: MashkourPic,
	},
	{
		full_name: 'Abdoul Hamid Coulibaly',
		role: "Backend Developer",
		image_url: HamidPic,
	},
];

export default TeamMembers;
